import React from 'react';

import Button from 'components/Button';
import { TEXT_USER_LIST } from 'constants/string/texts';

const PopupAddExerciseVideoHeader = ({ options }) => {
  const handleItemOverview = () => {
    const from = (options.page - 1) * options.page_size + 1;
    const to = from + options.page_size - 1;
    const total = options.total;

    return `${from} - ${to > total ? total : to} / ${total} ${TEXT_USER_LIST.PART}`;
  };

  return (
    <>
      <div className="flex items-end justify-between gap-2 mt-2">
        <p className="text-sm opacity-85 text-gray-336">{handleItemOverview()}</p>
        <div className="flex space-x-4">
          <Button
            className={'text-sm filter w-35.5 h-10 '}
            onClick={() => {}}
            icon={
              <div className="relative mr-2.5">
                {options.video_category_id && <div className="w-2 h-2 absolute top-0 right-0 bg-danger-229 rounded-full"></div>}
                <img src={require('assets/resources/FilterAlt.svg').default} alt="plus icon" width={18} height={18} />
              </div>
            }
            text={TEXT_USER_LIST.TEXT_FILTER}
            color="outline"
          />
        </div>
      </div>
    </>
  );
};

export default React.memo(PopupAddExerciseVideoHeader);
